<template>
  <ToolTipComponent
    v-if="showTooltip"
    placement="right"
  >
    <template #content> {{item.label}} </template>
    <fwb-sidebar-item
      v-bind="item.path ? { to: item.path } : {}"
      :class="navItemClassesCollapse"
      @click="$emit('navigate', item.path)"
    >
      <template #icon>
        <img
          :src="item.icon"
          :alt="item.alt"
          width="24"
          height="24"
          class="shrink-0"
        >
      </template>
    </fwb-sidebar-item>
  </ToolTipComponent>

  <fwb-sidebar-item
    v-else
    v-bind="item.path ? { to: item.path } : {}"
    :class="navItemClasses"
    @click="$emit('navigate', item.path)"
  >
    <template #icon>
      <img
        :src="item.icon"
        :alt="item.alt"
        width="24"
        height="24"
        class="shrink-0"
      >
    </template>
    <template v-if="!isCollapsed" #default>
      <span class="text-white">{{ item.label }}</span>
    </template>
  </fwb-sidebar-item>
</template>

<script setup>
import { computed } from 'vue';
import { FwbSidebarItem} from 'flowbite-vue';
import ToolTipComponent from "@/components/common/ToolTipComponent.vue";

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  isCollapsed: {
    type: Boolean,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  },
  showTooltip: {
    type: Boolean,
    default: false
  }
});

defineEmits(['navigate']);

const navItemClasses = computed(() => [
  'm-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray',
  { '!bg-darkgray': props.isActive }
]);
const navItemClassesCollapse = computed(() => [
  'mx-2.5 my-2 w-10 h-10 text-base font-normal text-white items-center transition duration-75 rounded-lg group hover:!bg-darkgray',
  { '!bg-darkgray': props.isActive }
]);
</script>